// Single source of truth for the current admissions cycle. Update this one value each
// year — everything that displays the cohort year or the orientation deadline reads
// from here, instead of a hardcoded year/date scattered across components and data files.
export const EXAM_CYCLE_YEAR = 2026;

// Orientation platform inscription deadline for this cycle (15 July, end of day).
export const ORIENTATION_DEADLINE = new Date(`${EXAM_CYCLE_YEAR}-07-15T23:59:00`);

export function getDaysUntilDeadline(): number {
  const diff = ORIENTATION_DEADLINE.getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / 86400000));
}
